import { AxiosRequestConfig } from "axios";
import { VUE_APP_PASSELIVRE_AUTH_TOKEN } from "@/commons/config";

export const beneficiarioHandleRequest = (config: AxiosRequestConfig) => {
  
  const token = VUE_APP_PASSELIVRE_AUTH_TOKEN;

  const authHeader = token ? `Bearer ${token}` : "";
  config.headers = {
    ...config.headers,
    Authorization: authHeader,
    Accept: "application/json",
    "Content-Type": "application/json"
  };

  return config;
};

export const beneficiarioHandleErrorRequest = (error: any) =>
  Promise.reject(error);
